import * as api from './requests';
import { setCountryOptions } from './components/Wizard2/selectOptions'
import ls from 'local-storage'
import store from './store'
import shortid from 'shortid'

export const setSelectedDetails = (details) => ({
  type: "SET_SELECTED_DETAILS",
  details
})

export const setAppSettings = (appSettings) => ({
  type: "SET_APP_SETTINGS",
  appSettings
})

const logInitializationError = (key, err) => {
  console.groupCollapsed("%cInitialization Error", 'color: rgb(240, 128, 128);')
  console.warn(`During initialization, the app setting: "${key}" failed with the attached error.`)
  console.error(err)
  console.groupEnd()
}

export const initializeApp = () => (dispatch, getState) => {
  // get all of the app_settings. To get a new setting add it to the 'keys' array
  let keys = ['USE_LDAP_AUTHENTICATION_YN', 'WEBSITE_PORTAL_OFFLINE_YN']
  if(process.env.FETCH_EDIT_USER_LINK){
    keys.push('EPASS_ACCOUNT_EDIT_URL')
  }
  let promises = keys.map(key => (
    new Promise((resolve) => {
      api.GET_APP_SETTING_BY_NAME(key, data => {
        if(data !== null){
          resolve(data)
        }else{
          logInitializationError(key, "App setting not found.")
        }
      }, err => {
        logInitializationError(key, err)
        resolve(null)
      })
    })
  ))
  promises.push(new Promise((resolve, reject) => {
    api.GET_GROUP_ITEMS('COUNTRY', countries => {
      setCountryOptions(countries.options)
      resolve()
    })
  }))

  Promise.all(promises).then((responses)=>{
    const app_settings = responses.filter(x=>x).reduce((accum, curr, currIdx, arr) => {
      return accum = {...accum, [curr.NAME]: transformAppSettingValue(curr.VALUE)}
    }, {})
    dispatch(setAppSettings(app_settings));
  })
}

const transformAppSettingValue = value => {
  switch (value) {
    case 'Y':
      return true;
    case 'N':
      return false;
    default:
      return value;
  }
}

export const toggleSidebarCollapse = (collapse) => ({
  type: "TOGGLE_SIDEBAR_COLLAPSE",
  collapse
})

export const toggleMobileState = (isMobile) => ({
  type: "TOGGLE_MOBILE_STATE",
  isMobile
})

export const toggleSidebarShow = (sidebarShown) => ({
  type: "TOGGLE_SIDEBAR_SHOW",
  sidebarShown
})

export const overrideSidebarResizing = (overrideSidebarResizing) => ({
  type: "OVERRIDE_SIDEBAR_RESIZING",
  overrideSidebarResizing
})

export const getState = () => (dispatch, getState) => (getState())

export const toggleLoginModal = (showLogin) => ({ 
  type: "TOGGLE_SHOW_LOGIN",
  showLogin 
})

export const setStateUser = (stateUser) => ({
  type: "SET_STATE_USER", 
  stateUser
})

export const clearAppError = () => ({
  type: "CLEAR_APP_ERROR"
})

export const setErrorToast = error => ({
  type: "SET_ERROR_TOAST",
  error
})

export const clearErrorToast = () => ({
  type: 'CLEAR_ERROR_TOAST'
})

export const setSuccessToast = success => ({
  type: "SET_SUCCESS_TOAST",
  success
})

export const clearSuccessToast = () => ({
  type: 'CLEAR_SUCCESS_TOAST'
})

export const setOffline = offline => ({
  type: 'SET_OFFLINE',
  offline
})

export const announce = message => ({
  type: 'ANNOUNCE',
  message
})

export const resetFullAppState = () => (dispatch) => {
  dispatch({type: "@@SEARCH_RESET_STATE"})
  dispatch({type: "@@fm/RESET_STATE"})
  dispatch({type: "@@DESIGNER_RESET_STATE"})
  dispatch({type: "RESET_WIZARD_STATE"})
  // dispatch({type: "@@h/RESET_STATE"})
  dispatch({type: "RESET_WORK_QUEUE_STATE"})
  dispatch({type: "@@mr/RESET_STATE"})
}

export const setCartQuantity = quantity => dispatch => {
  ls.set('CART_QUANTITY', {quantity, trigger: shortid.generate()})
  dispatch({
    type: 'SET_CART_QUANTITY',
    quantity
  })
}

export const clearCartQuantity = () => ({
  type: 'CLEAR_CART_QUANTITY'
})

export const getAndSetCartQuantity = () => dispatch => {
  if(process.env.SHOPPING_CART){
    api.GET_WEB_USER_ACTIVE_CART(cart => {
      dispatch(setCartQuantity((cart.RECEIPT_ITEM_CONTAINER_WEB_LIST.filter(x => !x.IS_FREE)).length))
    }, err => console.error)
  }
}

ls.on('CART_QUANTITY', value => {
  if(value && value.quantity && store.getState().app.cartQuantity !== value.quantity){
    store.dispatch(setCartQuantity(value.quantity))
  }
});



// WEBPACK FOOTER //
// ./src/actions.js